import { THEME } from '../globalTypes';
import { SHADOWS, GRAY_COLORS, FONT_WEIGHTS } from '../globalTheme';

export const TOOLTIP_THEME: Record<THEME, { backgroundColor: string; color: string }> = {
	dark: { backgroundColor: GRAY_COLORS.gray900, color: 'white' },
	light: { backgroundColor: 'white', color: GRAY_COLORS.gray700 }
};

export function getTooltipStyles() {
	return {
		tooltipWrapperCss: {
			display: 'inline-block'
		},
		tooltipTitle: {
			color: GRAY_COLORS.gray700,
			fontWeight: FONT_WEIGHTS.semibold
		},
		containerCss: (theme: THEME) => ({
			backgroundColor: TOOLTIP_THEME[theme].backgroundColor,
			color: TOOLTIP_THEME[theme].color,
			boxShadow: SHADOWS.md,
			borderRadius: '8px',
			maxWidth: '320px',
			padding: '12px 16px'
		})
	};
}
